import { render } from "./RevenueByBranches.vue?vue&type=template&id=fc06358a&scoped=true&ts=true"
import script from "./RevenueByBranches.vue?vue&type=script&lang=ts"
export * from "./RevenueByBranches.vue?vue&type=script&lang=ts"

import "./RevenueByBranches.vue?vue&type=style&index=0&id=fc06358a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc06358a"]])

export default __exports__